import React from "react";
import styles from "./Header.module.css";
import PropTypes from "prop-types";
import PrivacyLocked from "../../assets/Privacy-Locked.svg";
import PrivacyUnlocked from "../../assets/Privacy-Unlocked.svg";

/**
 * A view component that displays a header with a customizable title and icon
 * Components can be passed into the children prop to display in the middle
 */

export function Header({
  title,
  icon,
  children,
  isLock,
  isHide,
  setToggleInfo,
  onRefresh,
  isLoading,
}) {
  return (
    <div className={styles.container}>
      <div className={styles.rowContainer}>
        <div>
          <div className={styles.titleContainer}>
            <span className={styles.icon}>
              <img src={icon} alt="" />
            </span>
            <span className={styles.title}>
              <h1>{title}</h1>
            </span>
          </div>
          {children && <span className={styles.children}>{children}</span>}
        </div>
        <div className={styles.rightSection}>
          {onRefresh && (
            <div className={styles.refreshIcon} onClick={onRefresh}>
              <svg
                className={isLoading ? styles.spinner : styles.spinnerStatic}
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.65,6.35C16.2,4.9 14.21,4 12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20C15.73,20 18.84,17.45 19.73,14H17.65C16.83,16.33 14.61,18 12,18A6,6 0 0,1 6,12A6,6 0 0,1 12,6C13.66,6 15.14,6.69 16.22,7.78L13,11H20V4L17.65,6.35Z"
                  fill="currentColor"
                />
              </svg>
            </div>
          )}
          {isLock && (
            <div>
              {isHide ? (
                <img
                  src={PrivacyLocked}
                  alt="locked-icon"
                  onClick={setToggleInfo}
                  className={styles.iconLock}
                />
              ) : (
                <img
                  src={PrivacyUnlocked}
                  alt="unlocked-icon"
                  onClick={setToggleInfo}
                  className={styles.iconLock}
                />
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

Header.propTypes = {
  // Displays the title on the header
  title: PropTypes.string,

  // Path for the image on the left
  icon: PropTypes.string,
};
